module.exports = __webpack_public_path__ + "img/R-Icon-red.92c33009.png";